import type { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { tenantType } from '@atlassiansox/analytics-web-client';

import type { useAnalyticsClient } from '@/analytics/wac-analytics/analytics-client';

export const HOLDOUT_EXCLUSION_ANALYTICS_SUBJECT = 'jiraFY27H1HoldoutExclusion';

/**
 * Fires the `jiraFY27H1HoldoutExclusion triggered` track event synchronously.
 *
 * Sets the tenant on the shared analytics client immediately before firing so
 * the event carries it. This is idempotent — `<AnalyticsClientUpdater />` sets
 * the same value.
 *
 * Extracted as a plain function so it can be called both from the
 * `JiraFY27H1HoldoutExclusionTrigger` component (async resolve path) and
 * directly in `siteSelected` (sync navigation path, where a component's
 * useEffect would never run before page unload).
 */
export const fireHoldoutExclusionAnalytics = ({
	analyticsClient,
	createAnalyticsEvent,
	cloudId,
}: {
	analyticsClient: NonNullable<ReturnType<typeof useAnalyticsClient>>;
	createAnalyticsEvent: ReturnType<typeof useAnalyticsEvents>['createAnalyticsEvent'];
	cloudId: string;
}) => {
	analyticsClient.setTenantInfo(tenantType.CLOUD_ID, cloudId);

	createAnalyticsEvent({
		eventType: 'track',
		actionSubject: HOLDOUT_EXCLUSION_ANALYTICS_SUBJECT,
		action: 'triggered',
	}).fire();
};
